module.exports = __webpack_public_path__ + "img/infoNl.33455b4e.svg";